<div>
  <mat-card class="description-card">
    <h2>{{ 'ROLES.DESCRIPTION.TITLE' | translate }}</h2>
    <mat-accordion>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4 class="desc-title">
              {{ 'ROLES.DESCRIPTION.ROLE1.TITLE' | translate }}
            </h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <h4 class="nobreak">
          {{ 'ROLES.DESCRIPTION.ROLE1.DESC' | translate }}
        </h4>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4 class="desc-title">
              {{ 'ROLES.DESCRIPTION.ROLE2.TITLE' | translate }}
            </h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <h4 class="nobreak">
          {{ 'ROLES.DESCRIPTION.ROLE2.DESC' | translate }}
        </h4>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4 class="desc-title">
              {{ 'ROLES.DESCRIPTION.ROLE3.TITLE' | translate }}
            </h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <h4 class="nobreak">
          {{ 'ROLES.DESCRIPTION.ROLE3.DESC' | translate }}
        </h4>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4 class="desc-title">
              {{ 'ROLES.DESCRIPTION.ROLE8.TITLE' | translate }}
            </h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <h4 class="nobreak">
          {{ 'ROLES.DESCRIPTION.ROLE8.DESC' | translate }}
        </h4>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4 class="desc-title">
              {{ 'ROLES.DESCRIPTION.ROLE4.TITLE' | translate }}
            </h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <h4 class="nobreak">
          {{ 'ROLES.DESCRIPTION.ROLE4.DESC' | translate }}
        </h4>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4 class="desc-title">
              {{ 'ROLES.DESCRIPTION.ROLE5.TITLE' | translate }}
            </h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <h4 class="nobreak">
          {{ 'ROLES.DESCRIPTION.ROLE5.DESC' | translate }}
        </h4>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4 class="desc-title">
              {{ 'ROLES.DESCRIPTION.ROLE6.TITLE' | translate }}
            </h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <h4 class="nobreak">
          {{ 'ROLES.DESCRIPTION.ROLE6.DESC' | translate }}
        </h4>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4 class="desc-title">
              {{ 'ROLES.DESCRIPTION.ROLE7.TITLE' | translate }}
            </h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <h4 class="nobreak">
          {{ 'ROLES.DESCRIPTION.ROLE7.DESC' | translate }}
        </h4>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4 class="desc-title">
              {{ 'ROLES.DESCRIPTION.ROLE9.TITLE' | translate }}
            </h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <h4 class="nobreak">
          {{ 'ROLES.DESCRIPTION.ROLE9.DESC' | translate }}
        </h4>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card>
</div>
